'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialCodepen = function IoSocialCodepen(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.3 23.8c0.1 0 0.3 0.2 0.3 0.3v4.1s-4.9-3.2-7.3-4.8l3-2.1c0.2 0 0.3 0 0.4 0 1.2 0.8 2.5 1.7 3.6 2.5z m-3.6-5c0 0.1-0.2 0.1-0.3 0-1-0.7-2-1.3-3.1-2 2.4-1.6 7.3-4.8 7.3-4.8v3.9c0 0.2-0.2 0.4-0.3 0.5-1.1 0.8-2.4 1.6-3.6 2.4z m5.9-2.5c-0.1 0-0.2-0.1-0.2-0.2v-4.2l7.3 4.9-3.1 2c-0.1 0.1-0.3 0.1-0.3 0-1.3-0.8-2.5-1.6-3.7-2.5z m-0.9 1.7c0.4 0.3 3.1 2.1 3.1 2.1l-3.1 2c-0.1 0.1-0.3 0.1-0.4 0l-3.1-2s1.3-0.9 2-1.3c0.4-0.3 0.7-0.5 1.1-0.8 0 0 0.3-0.1 0.4 0z m-9.2 0.5l2.4 1.6-2.4 1.5v-3.1z m9-16c9.7 0 17.5 7.8 17.5 17.5s-7.8 17.5-17.5 17.5-17.5-7.8-17.5-17.5 7.8-17.5 17.5-17.5z m10.9 20.7v-6.3c0-0.5-0.2-0.7-0.6-1-3.2-2.1-6.5-4.3-9.7-6.4-0.4-0.3-0.8-0.3-1.3 0-3.2 2.1-6.3 4.3-9.5 6.4-0.4 0.2-0.7 0.6-0.7 1.1v6.2c0 0.5 0.3 0.8 0.7 1 3.2 2.1 6.3 4.3 9.5 6.4 0.5 0.3 0.9 0.3 1.3 0 3.2-2.1 6.4-4.3 9.6-6.4 0.4-0.2 0.7-0.5 0.7-1z m-6.2-1.9c0.1-0.1 0.4-0.1 0.5 0l3 2.1-7.3 4.8v-4c0-0.2 0.1-0.3 0.3-0.4 1.1-0.8 2.3-1.7 3.5-2.5z m4.2 0.3l-2.3-1.5 2.3-1.6v3.1z' })
        )
    );
};

exports.default = IoSocialCodepen;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-codepen.js
// module id = 2455
// module chunks = 0